import TaskPost from './modules/http-task';

export default {
  TaskPost,
};
